import React from 'react'
import { Link } from 'react-router-dom'

import './index.less'

const ServerError = () =>(
 
  <main className = "errorPage">
    <div className = "img-bar">
      <img className = "img-status" src = {require('../../assets/500.svg')} alt = "403" />
    </div>
    <div className = "tip">
      <span className = "tip-status">
        500
      </span>
      <span className = "tip-text">
        抱歉，服务器错误
      </span>
      <Link to = "/home" className = "tip-btn">返回首页</Link>
    </div>
  </main>

)

export default ServerError